// Utilidad simplificada para eliminar las protecciones de imágenes
// que evita usar métodos que podrían activar restricciones de seguridad

// Función para eliminar todas las protecciones de imágenes
export const removeAllImageProtections = () => {
  console.log('Desactivando protecciones de imágenes de forma simple...');

  // Usar setTimeout para ejecutar después de que el DOM se haya cargado
  setTimeout(() => {
    try {
      // 1. Permitir interacción en todas las imágenes
      document.querySelectorAll('img').forEach(img => {
        img.style.pointerEvents = 'auto';
        img.style.userSelect = 'auto';
        img.setAttribute('draggable', 'true');
      });

      // 2. Agregar un estilo que anule las restricciones
      const styleEl = document.createElement('style');
      styleEl.textContent = `
        img { 
          pointer-events: auto !important;
          user-select: auto !important;
          -webkit-user-select: auto !important;
          -moz-user-select: auto !important;
          -ms-user-select: auto !important;
          filter: none !important;
        }
        
        .image-container::after, 
        .protected-overlay, 
        .protected-layer {
          display: none !important;
        }
      `;
      document.head.appendChild(styleEl);
      
      console.log('Protecciones básicas desactivadas correctamente');
    } catch (err) {
      console.error('Error al desactivar protecciones:', err);
    }
  }, 1000);
};

// Versión alternativa más sencilla que solo modifica los estilos
export const simplifiedRemoveProtection = () => {
  // Esta es una versión simplificada que solo aplica estilos
  const style = document.createElement('style');
  style.innerHTML = `
    * {
      pointer-events: auto !important;
      user-select: auto !important;
      -webkit-user-select: auto !important;
    }
    
    img {
      pointer-events: auto !important;
      user-select: auto !important;
      -webkit-user-select: auto !important;
      filter: none !important;
    }
  `;
  document.head.appendChild(style);
  
  console.log('Protecciones simplificadas desactivadas');
};

export default {
  removeAllImageProtections,
  simplifiedRemoveProtection
};